module.exports = __webpack_public_path__ + "images/IG-LARP-Logo-gefuellt.png";